import React from 'react';
import ConfiguracionesSistemaCatalog from '../Components/Catalogos/Configuraciones/ConfiguracionesSistemaCatalog';

export default function ConfiguracionesSistemaPage() {
    return (
        <ConfiguracionesSistemaCatalog />
    );
}
